// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const nitreBed = defineModel({
  id: "nitre-bed",
  batchId: "future",
  name: "Nitre bed",
  tags: ["scenery","nitre","bed","low-poly","age-of-mcp","future"],
  summary: "A crusted nitre bed. Yields saltpetre for gunpowder, fertiliser and food preserving.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.7, 0.12, 0.6), color: "#6a5b42", position: [0, 0.06, 0] },
      { geometry: new THREE.BoxGeometry(0.6, 0.05, 0.5), color: "#cfc6a8", position: [0, 0.14, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: "#e2dabf", position: [-0.12, 0.16, 0.08], scale: [1.4, 0.4, 1.2] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#cfc6a8", position: [0.16, 0.16, -0.06], scale: [1.4, 0.4, 1.2] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#e2dabf", position: [0.06, 0.17, 0.18], scale: [1.3, 0.4, 1.2] },
    ],
  animations: [],
});
